import { createContext, useContext, useEffect } from 'react';
import { useUser, useClerk, useAuth as useClerkAuth } from '@clerk/clerk-react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const { user, isLoaded } = useUser();
  const { signOut } = useClerk();
  const { getToken, isSignedIn } = useClerkAuth();

  const logout = async () => {
    await signOut();
  };

  const getAuthToken = async () => {
    if (!isSignedIn) return null;
    try {
      const token = await getToken({ template: undefined });
      return token;
    } catch (err) {
      console.error('getToken error:', err);
      return null;
    }
  };

  useEffect(() => {
    const registerPushPlayer = async () => {
      if (!isSignedIn || !user) return;
      try {
        const OneSignal = window.OneSignal;
        // isPushNotificationsEnabled()/getUserId() are OneSignal Web SDK v1
        // API — react-onesignal ^3.5.1 wraps the v16 SDK, which replaced
        // both with these properties (not async methods) on
        // User.PushSubscription. Calling the old names threw "is not a
        // function" on every single page load, so push registration for
        // web never actually ran.
        if (!OneSignal?.User?.PushSubscription) return;
        const optedIn = OneSignal.User.PushSubscription.optedIn;
        if (!optedIn) return;
        const playerId = OneSignal.User.PushSubscription.id;
        if (!playerId) return;
        const token = await getAuthToken();
        if (!token) return;
        await axios.post(
          `${API}/push/register`,
          { player_id: playerId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (err) {
        console.error('Push registration error:', err);
      }
    };

    if (isLoaded && isSignedIn) {
      registerPushPlayer();
    }
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, isSignedIn, user]);

  return (
    <AuthContext.Provider value={{ user, loading: !isLoaded, logout, getToken: getAuthToken, isSignedIn }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
